import {
  AlertCircle,
  AlertTriangle,
  CheckCircle2,
  XCircle,
} from "lucide-react";
import { useTranslate } from "ra-core";
import type { ComponentType } from "react";

import { cn } from "@/lib/utils";
import type { OperationSemaphore } from "../types";

const SEMAPHORE_STYLES: Record<
  OperationSemaphore,
  { Icon: ComponentType<{ className?: string }>; className: string }
> = {
  verde: { Icon: CheckCircle2, className: "bg-[#E7F5EC] text-[#23794A]" },
  amarillo: { Icon: AlertCircle, className: "bg-[#FDF6D3] text-[#7A6500]" },
  naranja: { Icon: AlertTriangle, className: "bg-[#FCEBDD] text-[#A5411F]" },
  rojo: { Icon: XCircle, className: "bg-[#FBE7E4] text-[#B3321C]" },
};

/** Semaforo of an operation: always an icon AND text, never colour alone. */
export const SemaphoreBadge = ({
  value,
}: {
  value: OperationSemaphore | null | undefined;
}) => {
  const translate = useTranslate();
  if (!value || !SEMAPHORE_STYLES[value]) return null;
  const { Icon, className } = SEMAPHORE_STYLES[value];
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-medium",
        className,
      )}
    >
      <Icon className="size-3.5" aria-hidden="true" />
      {translate(`crm.operations.semaphore.${value}`)}
    </span>
  );
};

/** Plain text label of a commercial or administrative state. */
export const StatusLabel = ({
  kind,
  value,
}: {
  kind: "commercial" | "administrative";
  value: string | null | undefined;
}) => {
  const translate = useTranslate();
  if (!value) return null;
  return <span>{translate(`crm.operations.${kind}_status.${value}`)}</span>;
};
